import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=5c56debb&"
import script from "../assets/js/home.js?vue&type=script&lang=js&"
export * from "../assets/js/home.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports